import { AxiosRequestConfig, AxiosResponse } from "axios";
import AxiosActions from "../../AxiosActions";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import { TListApiResponse } from "../commonTypes";

enum KeyType {
    JOURNEY = "journey",
    IMPORT = "import",
    PERSON = "person",
    ORDER = "order",
}
/**
 * The category of a label tag as the query APIs return it. Value-list attributes can come back as a single-element
 * array (GraphQL does this, e.g. ["Person"]), so normalise them to the plain category name.
 */
export const toLabelTagType = (type: string | string[] | undefined): string | undefined => (Array.isArray(type) ? type[0] : type);

type TLabelTagList = {
    id: number;
    name: string;
    isActive: boolean;
    type: string;
    created: string;
    updated: string;
};
export const addLabelTag = (key: `${KeyType}`, data: number[], config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/tag/${key}`, data, config, spinner);
};

export const removeLabelTag = (data: { instanceIds: number[] }, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/tag/remove`, data, config, spinner);
};

type TData = {
    disable: boolean; // optional: if true, the source tag will be disabled after migration
    targetTag: {
        id?: number; // optional: ID of the existing target tag
        name?: string; // required if ID is not provided: name of the target tag
    };
};

export const migrateLabelTag = (tagId: number | string, data: TData, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/tag/${tagId}/migrate`, data, config, spinner);
};
export const getLabelTags = (dto, config: AxiosRequestConfig, spinner = false): Promise<AxiosResponse<TListApiResponse<TLabelTagList>>> => {
    return AxiosActions.post(getAxiosInstances().V3, "/health/grid/label-tag", dto, config, spinner);
};

export const createLabelTag = (data: { name: string; type: string }, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, "/tag", data, config, spinner);
};

export const updateLabelTag = (
    id: number,
    data: { name?: string; active?: boolean },
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.put(getAxiosInstances().V2, `/tag/update/${id}`, data, config, spinner);
};

export const getLabelTagDetails = (id: number, config: AxiosRequestConfig = {}, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/tag/${id}/details`, config, spinner);
};
